import { NgModule } from '@angular/core';
import { ActionButtonComponent } from '../../ui-kit/action-button/action-button.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { ProfilesDialogComponent } from './profiles-dialog.component';
import { ListFilterComponent } from '../../ui-kit/list-filter';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ProfilesDialogComponent],
  imports: [IntrackFeatureModule, ActionButtonComponent, ListFilterComponent, TranslateModule.forChild({})],
  exports: [ProfilesDialogComponent],
})
export class ProfilesDialogModule {}
